import { InvoiceStatus } from '@enums/invoice-status.enum';
import { StatusColor } from '@enums/status-color.enum';

export const INVOICE_STATUS_COLOR: Record<InvoiceStatus, StatusColor> = {
  [InvoiceStatus.sent]: StatusColor.grey4,
  [InvoiceStatus.draft]: StatusColor.grey4,
  [InvoiceStatus.saved]: StatusColor.grey4,
  [InvoiceStatus.paid]: StatusColor.accent,
  [InvoiceStatus.cancelled]: StatusColor.warn
};
